import React from 'react';
import { classNames } from 'helpers/style/classNames';
import useStyle from './headerText.style';

type Emoji = {
  url: string;
  alt: string;
};

export interface HeaderTextProps {
  isOnDashboardTitle?: boolean;
  text: string;
  emoji: Emoji;
  color?: 'default' | 'white';
  fontsize?: 'medium' | 'small';
  marginTop?: boolean;
}

export const HeaderText = ({
  text,
  isOnDashboardTitle = false,
  emoji,
  color = 'default',
  fontsize = 'medium',
  marginTop = false
}: HeaderTextProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames([classes.root, classes[color], classes[fontsize]], {
        condition: marginTop,
        classe: classes.marginTop
      })}
    >
      {isOnDashboardTitle && (
        <span className={classes.semiBold}>Bonjour, </span>
      )}
      <h1 className={`${classes.title} ${classes[fontsize]}`}>{text}</h1>
      {emoji && (
        <img className={classes.emoji} src={emoji.url} alt={emoji.alt} />
      )}
    </div>
  );
};
